<template>
  <div id="map-container">
    <h1 class="title">Action Takers</h1>
    <div id="mapbox-map" />
  </div>
</template>

<script>
import mapboxgl from 'mapbox-gl';
import axios from 'axios';
// https://docs.mapbox.com/mapbox-gl-js/overview/#quickstart
export default {
  data() {
    return {
      secWavePins: [],
      initPins: [],
      map: null
    };
  },
  created() {
    this.setPins(
      process.env.VUE_APP_INIT_PIN_LIMIT,
      process.env.VUE_APP_TOTAL_PIN_LIMIT,
      process.env.VUE_APP_RSVPS_CAMPAIGN_ID, 
      process.env.VUE_APP_LAWMAKER_CAMPAIGN_ID, process.env.VUE_APP_EMAILS_CAMPAIGN_ID);
  }, 
  mounted() {
    this.initMapBoxMap()
  },
  watch: {
    initPins() {
      console.log(`adding ${this.initPins.length} # init pins`)
      this.addPins(this.initPins);
    },
    secWavePins() {
      setTimeout(() => {
      console.log(`adding ${this.secWavePins.length} # second wave pins`)
        this.addPins(this.secWavePins)
        console.log('finishing second wave')
      }, process.env.VUE_APP_SECOND_WAVE_DELAY)
    }
  },
  methods: {
    addPins(array) {
        array.forEach((subArr) => {
        new mapboxgl.Marker()
        // platform gives reverses LatLon
          .setLngLat([subArr[1], subArr[0]])
          .addTo(this.map);
      })
    },
    initMapBoxMap() {
      mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN;
      this.map = new mapboxgl.Map({
        container: 'mapbox-map',
        center: [
          process.env.VUE_APP_MAPBOX_CENTER_LAT,
          process.env.VUE_APP_MAPBOX_CENTER_LON
        ],
        zoom: process.env.VUE_APP_MAPBOX_ZOOM,
        style: process.env.VUE_APP_MAPBOX_STYLE,
        interactive: false
      });
      this.map.addControl(new mapboxgl.NavigationControl()
      );

      var width = window.innerWidth

      // process.env.VUE_APP_MAPBOX_ZOOM_MOBILE(width)
      if (width <= 1400 && width >= 1025) {
        this.map.setZoom(5.7)
      } else if (width <= 1024 && width >= 769) {
        this.map.setZoom(5.5)
      } else if (width <= 768 && width >= 601) {
        this.map.setZoom(5.6)
      }  else if (width <= 600 && width >= 415) {
        this.map.setZoom(5.4)
      }else if (width <= 414 && width >= 376) {
        this.map.setZoom(4.8)
      } else if (width <= 375) {
        this.map.setZoom(4.5)
      }
    },
    async setPins(initLimit, totalLimit, ...campaignIds) {
      const getPinPromises = campaignIds.map((campaignId) => {
        return this.getPins(campaignId);
      })
      const data = await Promise.all(getPinPromises);
      const latLon = data.flat().slice(0, totalLimit);
      this.initPins = latLon.slice(0, process.env.VUE_APP_INIT_PIN_LIMIT)
      this.secWavePins = latLon.slice(process.env.VUE_APP_INIT_PIN_LIMIT)
      ;
    },
    async getPins(campaignId) {
      let response;
      try {
        response = await axios({
          method: 'get',
          url: process.env.VUE_APP_GET_MAP_MARKERS,
          params: {
            campaignId,
            customerId: process.env.VUE_APP_CUSTOMER_ID,
          }
        })
        if (response) {
          const { data: { coords }} = response;
          response = coords || [];
        }
      } catch (e) {
        console.log('No pin coords were returned due to error: ', e)
        response = [];
      }
      return response;
    }
  }
};
</script>

<style>
  #map-container {
    height: 80vh;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  @media (min-width: 1080px) {
    #map-container {
      height: 55vh;
    }
  }
  @media (max-width: 768px) {
    #map-container {
      height: 35vh !important;
      align-items: center; 
    }
  }
  @media (max-width: 414px) {
    #map-container {
      order: -1;
      margin-bottom: .5rem;
    } 
  }
  #mapbox-map {
    bottom: 0;
    height: 100%;
    top: 0;
    width: 100%;
  }
  @media (max-width: 768px) {
    #mapbox-map {
      width: 100%;
    }
  }
  @media (max-width: 1024px) {
    #map-container {
      height: 54vh;
    }
  }
</style>